import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { Header, Wrapper, Logo } from "./styles"
import { Navbar, Nav } from "react-bootstrap"
import { AiOutlineMenu } from "react-icons/ai"

const MENU_QUERY = graphql`
  query {
    allAgilitySitemapNode {
      edges {
        node {
          languageCode
          path
          menuText
          pageID
        }
      }
    }
  }
`

const GlobalHeader = props => {
  // get data for menu links
  const data = useStaticQuery(MENU_QUERY)

  const path = props.location

  // build view model
  const viewModel = {
    item: props.headerData,
    menuLinks: data.allAgilitySitemapNode.edges.filter(sitemapNode => {
      let isTopLevelPage = sitemapNode.node.path.split("/").length === 2
      const isThisLanguage =
        sitemapNode.node.languageCode === props.languageCode
      if (props.isMultiLanguage) {
        isTopLevelPage = sitemapNode.path.split("/").length === 3
      }
      //only return nodes from this language and top level links only
      return isThisLanguage && isTopLevelPage
    }),
  }

  return (
    <Header>
      <div
        className={`${
          path.pathname === "/" ? "fixed-header-container" : `header-container`
        }`}
      >
        <Wrapper>
          <Navbar bg="dark" expand="md">
            <Navbar.Brand>
              <Link to="/">
                <Logo src={viewModel.item.logo.url} alt="Aion Therapeutic" />
              </Link>
            </Navbar.Brand>
            <Navbar.Toggle>
              <AiOutlineMenu />
            </Navbar.Toggle>
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ml-auto">
                {viewModel.menuLinks.map((link, i) => (
                  <Link key={i} to={link.node.path} activeClassName="active">
                    {link.node.menuText}
                  </Link>
                ))}
              </Nav>
            </Navbar.Collapse>
          </Navbar>
        </Wrapper>
      </div>
    </Header>
  )
}

export default GlobalHeader
